module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAWMAAAABCAYAAAALic8EAAAAG0lEQVQ4jWMs3/73P8MoGAWjYBSMgoEDDAwMAJNjAywaoF0nAAAAAElFTkSuQmCC"